var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.40747 2.7037V12.9259C4.40747 13.3778 4.58697 13.8111 4.90647 14.1306C5.22598 14.4501 5.65932 14.6296 6.11117 14.6296H12.926C13.3778 14.6296 13.8112 14.4501 14.1307 14.1306C14.4502 13.8111 14.6297 13.3778 14.6297 12.9259V5.46541C14.6297 5.23844 14.5843 5.01377 14.4962 4.80458C14.4082 4.59539 14.2792 4.40591 14.1169 4.24726L11.293 1.48556C10.9747 1.17434 10.5473 1.00006 10.1021 1H6.11117C5.65932 1 5.22598 1.1795 4.90647 1.499C4.58697 1.81851 4.40747 2.25185 4.40747 2.7037V2.7037Z",
    stroke: "url(#paint0_linear_1133_14032)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.2222 14.6296V16.3334C11.2222 16.7852 11.0427 17.2185 10.7232 17.5381C10.4037 17.8576 9.97037 18.0371 9.51852 18.0371H2.7037C2.25185 18.0371 1.81851 17.8576 1.499 17.5381C1.1795 17.2185 1 16.7852 1 16.3334V6.96298C1 6.51113 1.1795 6.07779 1.499 5.75828C1.81851 5.43877 2.25185 5.25928 2.7037 5.25928H4.40741",
    stroke: "url(#paint1_linear_1133_14032)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1133_14032",
    x1: 1.53024,
    y1: 1,
    x2: 16.8773,
    y2: 2.0938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1133_14032",
    x1: -1.87723,
    y1: 5.25928,
    x2: 13.4592,
    y2: 6.42519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678AF5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyOutlined);
export default __webpack_public_path__ + "static/media/copy-outlined.6d0b598eaf766768b889b7235e9b9fbb.svg";
export { ForwardRef as ReactComponent };